import { CustomAttributeFloorsDistributionNumeric } from "@api/client";

export const mapApiResponseToFloorOrModulesArray = (response?: CustomAttributeFloorsDistributionNumeric) => {
  if (response === undefined || response.valueMin === undefined || response.valueMax === undefined) {
    return undefined;
  }
  return [response.valueMin, response.valueMax];
};
